module.exports = __webpack_public_path__ + "static/media/GreenCheckLarge.10a091b5.svg";